import {Button, Grid, MenuItem, Select, Stack, styled, Typography} from "@mui/material";
import InfoTooltip from "../../components/InfoTooltip";

const IncDecButton = styled('div')({
    height: '20px', width: '20px', backgroundColor: 'rgb(0,0,0,0.3)', textAlign: 'center', userSelect: 'none', borderRadius: '3px'
})

const tooltipText = 'Choose how many headshots to use for calculating TTK and STK. Headshots will hit first, then body shots afterwards.';
const MultipliersSettings = ({settings, handleMultiplierValue}) => {
    return <Grid item xs={12}>
        <Stack direction='row' justifyContent='start' alignItems='center' sx={{p: '0 20px 15px 0', pl: {xs: '15px', md: '25px'}}}>
            <Typography variant='h7' sx={{marginBottom: '3px'}}>
                Headshots:
            </Typography>
            <InfoTooltip text={tooltipText}/>
            <Stack direction='row' alignItems='center' sx={{ml: '5px'}}>
                <IncDecButton onClick={() => handleMultiplierValue(settings.multipliers.head - 1)}>-</IncDecButton>
                <Typography sx={{p: '0 5px', userSelect: 'none'}}>{settings.multipliers.head}</Typography>
                <IncDecButton onClick={() => handleMultiplierValue(settings.multipliers.head + 1)}>+</IncDecButton>
            </Stack>
            {/*<Select*/}
            {/*    value={settings.multipliers.head}*/}
            {/*    onChange={e => handleMultiplierValue(e)}*/}
            {/*    displayEmpty*/}
            {/*    sx={{height: '30px', ml: '5px'}}*/}
            {/*>*/}
            {/*    {*/}
            {/*        [...Array(16).keys()].map((num) => {*/}
            {/*            return <MenuItem value={num}>{num}</MenuItem>*/}
            {/*        })*/}
            {/*    }*/}
            {/*</Select>*/}
        </Stack>
    </Grid>;
}

export default MultipliersSettings